
interface DeviceChangeIconProps {
  className?: string;
  size?: string;
}

const DeviceChangeIcon = ({ className, size }: DeviceChangeIconProps) => {
  const Size = size ?? '20';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      className= {className}
    >
      <g
        fill="none"
        stroke="#bc2929"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M15 20h-1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
        <path d="M18 8V5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9m6 4v.01M19 19a2.003 2.003 0 0 0 .914-3.782a1.98 1.98 0 0 0-2.414.483M16 9h2" />
      </g>
    </svg>
  );
};

export default DeviceChangeIcon;
